import React from 'react';
import InfoTooltip from '../common/InfoTooltip';

const SectionHeader = ({ title, subtitle, infoText }) => {
  return (
    <div className="flex items-center justify-between mb-3">
      <div>
        <div className="flex items-center">
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          {infoText && (
            <div className="ml-2">
              <InfoTooltip text={infoText} />
            </div>
          )}
        </div>
        {subtitle && <p className="text-sm text-gray-600 mt-0.5">{subtitle}</p>}
      </div>
    </div>
  );
};

export default SectionHeader;